'use client';

import Image from 'next/image';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { Button } from '@/components/ui/button';

export default function MenuPage() {
  return (
    <div className="w-full" style={{ backgroundColor: 'hsl(35 100% 97%)' }}>
      <Navbar />

      {/* Hero Section */}
      <section className="section-cream texture-cream py-16 sm:py-20 px-4">
        <div className="container mx-auto text-center max-w-3xl">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-[#D71920] mb-4 sm:mb-6 uppercase tracking-tight">
            Menu
          </h1>
          <p className="text-lg sm:text-xl text-foreground mb-6 sm:mb-8 font-medium">
            Fresh halal smash burgers, fries, and crowd favorites. Made to order. Every time.
          </p>
        </div>
      </section>

      {/* Menu Image Section */}
      <section className="section-cream texture-cream py-12 sm:py-16 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="relative w-full">
            <Image
              src="/images/uploads/409f8873-0708-4e0b-b018-c0b1b03c3c23.png"
              alt="Mo's Burger Full Menu"
              width={1200}
              height={1600}
              className="w-full h-auto object-contain rounded-2xl sm:rounded-3xl border-2 border-[#D71920]/20 shadow-lg"
              sizes="(max-width: 768px) 100vw, (max-width: 1024px) 90vw, 1200px"
              priority
            />
          </div>
        </div>
      </section>

      {/* Order Section */}
      <section className="py-16 sm:py-20 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl font-black text-foreground mb-3 sm:mb-4 uppercase tracking-tight">
              Order Mo's Burger
            </h2>
            <p className="text-lg sm:text-xl text-foreground/70 font-medium">
              Order pickup through Toast or delivery through your favorite app.
            </p>
          </div>

          {/* Primary - Toast */}
          <div className="mb-12 sm:mb-16">
            <h3 className="text-center text-foreground/60 text-sm font-bold uppercase tracking-widest mb-6">Primary Ordering</h3>
            <div className="bg-white rounded-2xl sm:rounded-3xl border-2 border-[#D71920]/30 p-8 sm:p-12 shadow-md hover:shadow-lg transition-all">
              <div className="flex flex-col items-center gap-6">
                <div className="h-24 flex items-center justify-center">
                  <Image
                    src="/images/uploads/62b91694-83a9-4f17-853c-b61bb24c9f7b.png"
                    alt="Toast"
                    width={100}
                    height={100}
                    className="h-24 w-auto object-contain"
                  />
                </div>
                <div className="text-center">
                  <h3 className="text-2xl sm:text-3xl font-black text-[#333] mb-2">Toast</h3>
                  <p className="text-foreground/70 font-medium mb-6">
                    Order directly from our Toast platform for the fastest checkout
                  </p>
                </div>
                <Button
                  onClick={() => window.open('https://www.toasttab.com/local/order/mos-burger-llc-3709-s-george-mason-dr-1204e', '_blank')}
                  className="w-full bg-[#D71920] hover:bg-[#B01017] text-white font-black text-base sm:text-lg py-5 sm:py-6 rounded-lg shadow-lg hover:shadow-xl transition-all"
                >
                  Order on Toast
                </Button>
              </div>
            </div>
          </div>

          {/* Delivery Options */}
          <div>
            <h3 className="text-center text-foreground/60 text-sm font-bold uppercase tracking-widest mb-6">Delivery Options</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
              {/* Uber Eats */}
              <div className="bg-white rounded-2xl sm:rounded-3xl border-2 border-[#E8D8C3] p-6 sm:p-8 shadow-sm hover:shadow-md transition-all">
                <div className="flex flex-col items-center gap-4 h-full">
                  <div className="h-20 flex items-center justify-center w-full">
                    <Image
                      src="/images/uploads/ca48bb14-fd83-4e93-b7fb-4a8c7c99b85f.jpg"
                      alt="Uber Eats"
                      width={80}
                      height={80}
                      className="h-20 w-auto object-contain"
                    />
                  </div>
                  <div className="text-center flex-1">
                    <h3 className="text-lg sm:text-xl font-black text-[#333] mb-2">Uber Eats</h3>
                    <p className="text-sm text-foreground/70 font-medium mb-4">
                      Delivery via Uber Eats
                    </p>
                  </div>
                  <Button
                    onClick={() => window.open('https://www.ubereats.com/store/mos-burger-500-florida-avenue-northeast/OBre9dneUZSHCeqYN2bBMQ?diningMode=DELIVERY&ps=1&surfaceName=', '_blank')}
                    className="w-full bg-white border-2 border-[#D71920] text-[#D71920] hover:bg-[#D71920]/5 font-black text-sm sm:text-base py-3 sm:py-4 rounded-lg transition-all"
                  >
                    Order on Uber Eats
                  </Button>
                </div>
              </div>

              {/* DoorDash */}
              <div className="bg-white rounded-2xl sm:rounded-3xl border-2 border-[#E8D8C3] p-6 sm:p-8 shadow-sm hover:shadow-md transition-all">
                <div className="flex flex-col items-center gap-4 h-full">
                  <div className="h-20 flex items-center justify-center w-full">
                    <Image
                      src="/images/uploads/7698b3eb-5d87-4ebb-afed-699775d8cc01.png"
                      alt="DoorDash"
                      width={80}
                      height={80}
                      className="h-20 w-auto object-contain"
                    />
                  </div>
                  <div className="text-center flex-1">
                    <h3 className="text-lg sm:text-xl font-black text-[#333] mb-2">DoorDash</h3>
                    <p className="text-sm text-foreground/70 font-medium mb-4">
                      Delivery via DoorDash
                    </p>
                  </div>
                  <Button
                    onClick={() => window.open('https://www.doordash.com/store/37328131?src=yp&delivery=true&utm_source_id=3a4b9245-6353-4f6b-825a-695d0e735a11', '_blank')}
                    className="w-full bg-white border-2 border-[#D71920] text-[#D71920] hover:bg-[#D71920]/5 font-black text-sm sm:text-base py-3 sm:py-4 rounded-lg transition-all"
                  >
                    Order on DoorDash
                  </Button>
                </div>
              </div>

              {/* Grubhub */}
              <div className="bg-white rounded-2xl sm:rounded-3xl border-2 border-[#E8D8C3] p-6 sm:p-8 shadow-sm hover:shadow-md transition-all">
                <div className="flex flex-col items-center gap-4 h-full">
                  <div className="h-20 flex items-center justify-center w-full">
                    <Image
                      src="/images/uploads/bbc6eeec-c2d1-4367-abf7-7279020b936f.png"
                      alt="Grubhub"
                      width={80}
                      height={80}
                      className="h-20 w-auto object-contain"
                    />
                  </div>
                  <div className="text-center flex-1">
                    <h3 className="text-lg sm:text-xl font-black text-[#333] mb-2">Grubhub</h3>
                    <p className="text-sm text-foreground/70 font-medium mb-4">
                      Delivery via Grubhub
                    </p>
                  </div>
                  <Button
                    onClick={() => window.open('https://www.grubhub.com', '_blank')}
                    className="w-full bg-white border-2 border-[#D71920] text-[#D71920] hover:bg-[#D71920]/5 font-black text-sm sm:text-base py-3 sm:py-4 rounded-lg transition-all"
                  >
                    Order on Grubhub
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
